import React from 'react'
import HeroSection from '../OutletTemplate/HeroSection'
import CaseStudiesSection from '../HomeLanding/ComponentsIndiaPage/CaseStudiesSection'
import NewFaqSection from '../HomeLanding/HomeLandingComponents/NewFaqSection'
import NewsAndVideos from '../HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import FeaturesSection from '../OutletTemplate/FeaturesSection'
import styles from '../.././styles/outletTemplate.module.css'
import ReviewsSection from '../HomeLanding/ComponentsIndiaPage/ReviewsSection'
import BusinessUnlockSection from '../HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '../HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import { IAAPISection, ParksFeaturesSection, QueueBusterExperienceCentersSection, ThemeParkReviewsSection } from '../qbStrap'
import Image from 'next/image'
import EntertainmentClientsMarquee from './EntertainmentClientsMarquee'


const DesktopWaterPark = () => {
    const topSection = [
        {
            title: <>The Next-Gen POS Software for <br/>  Water Park Operations  </>,
            text: "Managing a water park means juggling thousands of guests, multiple entry points, poolside operations, F&B counters, lockers, and ride queues, all at the same time. Turn every splash into an unforgettable experience for your customers. QueueBuster brings it all under one powerful ticketing and billing software. From lightning-fast ticketing at the gate to real-time inventory updates, QueueBuster keeps your water park running at full speed, even on your busiest summer days.",
            centerImage: "/assets/waterPark/Desktop_image.webp",
            height: "38rem",
            width: "56rem",
            top: "-23rem",
            left: "24%",
            staticImages: [
                {
                    src: "/assets/waterPark/tubes1.svg",
                    alt: "Water park tubes",
                    width: "30rem",
                    height: "30rem",
                    bottom: "-10rem",
                    left: "12rem",
                    zIndex: 10,
                },
                {
                    src: "/assets/waterPark/tubes2.svg",
                    alt: "Water park tubes",
                    width: "30rem",
                    height: "30rem",
                    bottom: "-10rem",
                    right: "8rem",
                    zIndex: 10,
                },
                {
                    src: "/assets/waterPark/tubes3.svg",
                    alt: "Water park tubes",
                    width: "8rem",
                    height: "8rem",
                    bottom: "3rem",
                    left: "45rem",
                    zIndex: 10,
                },
            ],
            Image1: {
                src: "/assets/waterPark/quickbill.svg",
                alt: "Pet Store Image 1",
                width: "12rem",
                height: "12.5rem",
                left: "27rem",
                bottom: "29rem",
                zIndex: 20,

            },
            Image2: {
                src: "/assets/waterPark/alltickets.svg",
                alt: "Pet Store Image 1",
                width: "14rem",
                height: "6rem",
                bottom: "18rem",
                left: "16rem",

            },
            Image3: {
                src: "/assets/waterPark/discount.svg",
                alt: "Pet Store Image 1",
                width: "16rem",
                height: "6rem",
                bottom: "34rem",
                right: "20rem",

            },
            Image4: {
                src: "/assets/waterPark/tunnel.svg",
                alt: "Pet Store Image 1",
                width: "14rem",
                height: "16rem",
                bottom: "17rem",
                right: "9rem",
                zIndex: 20,

            },

        }
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What makes QueueBuster the ideal billing solution for water parks?
                </span>
            ),
            des: "QueueBuster is purpose-built to handle the unique operational demands of water parks, from managing thousands of guest entries on peak summer days to running multiple F&B kiosks, locker stations, and retail outlets simultaneously. Unlike generic POS systems, QueueBuster offers water park-specific features like RFID wristband integration, slot-based entry management. Its intuitive interface requires minimal staff training, making it easy to deploy across every touchpoint in your park.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do RFID wristbands work in a water park environment?
                </span>
            ),
            des: "QueueBuster software facilitates RFID management. Guests can load a prepaid balance onto their wristband at entry and use it to pay across wave pools, food kiosks, locker stations, retail shops, and activity zones, all with a simple tap. This eliminates the need for guests to carry cash or cards inside the park, making the experience safer, faster, and far more enjoyable. Every transaction is recorded in real time, giving your team instant visibility into spending patterns and helping you identify upsell opportunities throughout the day.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster handle large crowds during peak summer season?
                </span>
            ),
            des: "Absolutely. QueueBuster is engineered for high-volume, high-pressure environments and has been battle-tested at some of India's largest parks handling millions of visitors annually. The software supports simultaneous transactions across multiple entry gates, F&B counters, and activity zones without any lag or downtime. Slot-based entry management helps you control crowd density and prevent bottlenecks at popular attractions. Even during sudden footfall surges on weekends or holidays, QueueBuster ensures every transaction is processed instantly and every guest is served without unnecessary delays.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is QueueBuster compatible with locker management and activity tracking?
                </span>
            ),
            des: "Yes, QueueBuster integrates seamlessly with locker management systems, allowing guests to rent, access, and return lockers using their RFID wristband without any separate tokens or physical keys. Every locker transaction is logged and billed automatically through the central POS, reducing manual errors and staff dependency at locker stations. Beyond lockers, the system also tracks guest activity across rides, splash zones, and F&B outlets, giving you rich data on guest behavior and preferences. This activity data can be used to personalize offers, improve park layout decisions, and enhance the overall guest journey from entry to exit.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster manage F&B operations across multiple outlets in a water park?
                </span>
            ),
            des: "QueueBuster provides a fully unified F&B management system that connects every food counter, kiosk, café, and restaurant in your water park to a single backend. Real-time inventory tracking ensures that stock levels are always visible and automatic alerts prevent mid-rush stockouts at busy poolside counters. The quick-serve billing mode is designed for high-footfall environments where speed is critical, reducing wait times and improving guest satisfaction. Detailed outlet-wise performance reports help you identify bestselling items, track wastage, and make smarter decisions about menu planning, staffing, and pricing across your entire F&B operation.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How secure are cashless transactions through QueueBuster's RFID system?
                </span>
            ),
            des: "Security is built into every layer of QueueBuster's cashless transaction system. Each RFID wristband is uniquely encrypted and linked to a specific guest profile, ensuring that no unauthorized transactions can take place even if a wristband is lost or misplaced. Guests or park staff can instantly freeze a wristband from the central dashboard in case of any issue, and any remaining balance can be refunded or transferred without hassle. All transactions are logged with timestamps and counter details, giving you a complete and tamper-proof audit trail.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How quickly can QueueBuster be set up and deployed at our water park?
                </span>
            ),
            des: "QueueBuster is designed for fast, smooth deployment with minimal disruption to your park's daily operations. Our dedicated onboarding team works closely with your management to understand your park's layout, outlet structure, and operational requirements before configuring the system to fit perfectly. Staff training is kept short and simple thanks to QueueBuster's intuitive, easy-to-navigate interface; most teams are fully operational within just a couple of days. We also provide ongoing technical support and regular software updates to ensure your POS always performs at its best, whether it's a quiet weekday or your biggest summer weekend of the year.",
            id: 7,
            activeIndex: 0,
        },
    ]
    const waterParkFeatures = {
        centerImage2: "/assets/waterPark/Multi-Store-Inventory.webp",
        data: [
            {
                id: 1,
                image: "/assets/waterPark/box-office-center.png",
                icon: "/assets/waterPark/BoxOfficeTicketing_icon.svg",
                title: "Instant Billing Built for High-Footfall Water Parks",
                tag: "Box Office Ticketing",
                desc: <>QueueBuster POS is engineered for the fast-paced environment of water parks, where thousands of guests move through entry gates, wave pools, and food outlets every hour. The software handles high-volume transactions with zero lag, giving your staff the confidence to process tickets, snacks, and merchandise at peak speed without compromising accuracy. <br />
                    Built for busy environments, the easy interface lets staff operate from any device at any corner of the park, from counters to entry booths.</>,
                btnText: "Book a free demo",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                Image1: {
                    src: "/assets/waterPark/box-office-item-card.svg",
                    alt: "Water park ticket item card",
                    imageWidth: "13rem",
                    imageHeight: "17rem",
                    top: "-1rem",
                    right: "6rem",
                },
                Image3: {
                    src: "/assets/waterPark/box-office-discount-badge.svg",
                    alt: "Water park discount offer",
                    imageWidth: "20rem",
                    imageHeight: "8rem",
                    bottom: "4rem",
                    left: "-3rem",
                },


                points: [
                    <>Rapid billing at entry gates even during peak rush hours.</>,
                    <>Multiple payment modes, cash, card, UPI, and full contactless support.</>,
                    <>Minimal staff training required with an intuitive, easy-to-navigate UI.</>,
                    <>Operates on all kinds of devices, whether it's android or windows.</>,
                ],
            },
            {
                id: 2,
                image: "/assets/waterPark/on-the-go-center.png",
                tag: "On-The-Go Ticketing",
                icon: "/assets/waterPark/On-The-GoTicketing_icon.svg",
                title: "Sell and upsell beyond the box-office counter.",
                desc: <>With QueueBuster's On-The-Go Ticketing, your guests can purchase tickets, fast-track passes, merchandise, and RFID bands from wherever they are, whether inside the park or standing in the parking lot. This dramatically cuts gate congestion, especially on peak summer days, ensuring a smooth splash-in experience from the very first moment. <br />
                    All ticket sales, online, app, or walk-in, sync to a single real-time dashboard, eliminating overbooking and entry confusion.</>,
                btnText: "Contact Sales",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                Image1: {
                    src: "/assets/waterPark/on-the-go-rfid-badge.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "16rem",
                    imageHeight: "5rem",
                    top: "10rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/waterPark/badge2.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "18rem",
                    imageHeight: "15rem",
                    bottom: "2rem",
                    left: "0rem",
                },


                points: [
                    <>Sell day passes, combo packages, and activity slots from any channel.</>,
                    <>Slash entry queues with pre-validated RFID bands and QR tickets.</>,
                    <>Online and offline ticket data stays synchronized in real time.</>,
                    <>Slot-based entry management to control crowd density at peak hours.</>,
                ],
            },
            {
                id: 3,
                image: "/assets/waterPark/RFID_center.png",
                tag: "RFID Wristbands & Scanners",
                icon: "/assets/waterPark/RFIDScanners_icon.svg",
                title: "Faster, Cashless, and Completely Guest-Friendly.",
                desc: <>QueueBuster enables RFID wristbands that let guests load their balance once and spend freely across wave pools, slides, food outlets, and retail outlets, all with a simple tap of the wrist. No cash, no cards, no worries about wet pockets. <br />
                    Beyond payments, these wristbands track guest activity, locker access, and ride history, helping you deliver hyper-personalized experiences and smarter upsells on every visit.</>,
                imageWidth: "46rem",
                imageHeight: "42rem",
                btnText: "Contact Sales",

                Image1: {
                    src: "/assets/waterPark/rfid-badge.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "16rem",
                    imageHeight: "5rem",
                    top: "10rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/waterPark/rfid-badge1.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "18rem",
                    imageHeight: "18rem",
                    bottom: "-2rem",
                    left: "0rem",
                },

                points: [
                    <>RFID wristband enablement for seamless park access</>,
                    <>Guests top up once and tap to pay across every park touchpoint.</>,
                    <>Track locker usage, ride activity, and guest preferences in real time.</>,
                    <>Generate incremental revenue with on-the-go RFID bands recharge</>,
                ],
            },
            {
                id: 4,
                image: "/assets/waterPark/F&B_center.png",
                tag: "F&B Operations",
                icon: "/assets/waterPark/F&B_icon.svg",
                title: "Food & Beverage management, made effortless",
                desc: <>QueueBuster manages every F&B outlet under one roof. Real-time inventory tracking means your stock never runs out mid-rush, while fast billing keeps those snack lines moving even when the park is packed. <br />
                    Automated reports help you identify bestsellers, manage wastage, and optimize menu offerings, so your food business runs as smoothly as the rides.</>,
                imageWidth: "44rem",
                imageHeight: "44rem",
                btnText: "Book a free demo",
                Image1: {
                    src: "/assets/waterPark/f&b-badge.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "20rem",
                    imageHeight: "6rem",
                    top: "2rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/waterPark/f&b-badge1.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "20rem",
                    imageHeight: "8rem",
                    bottom: "5rem",
                    left: "0rem",
                },


                points: [
                    <>Unified billing across all food courts and restaurants.</>,
                    <>Live inventory alerts to prevent stockouts during peak hours.</>,
                    <>Flexibility to bill for food at the box office and F&B counters.</>,
                    <>Performance reports per outlet to drive smarter F&B decisions.</>,
                ],
            },
            {
                id: 5,
                image: "/assets/waterPark/Omnichannel_center.png",
                tag: "Omnichannel Booking Engine",
                icon: "/assets/waterPark/Omnichannel_icon.svg",
                title: "One Dashboard. Zero Chaos.",
                desc: <>Whether your guests book through your website, OTA platforms, or just walk in at the gate, QueueBuster's Omnichannel Booking Engine brings every reservation into a single, real-time control panel. No double bookings, no channel conflicts, no manual reconciliation, just clear visibility across every sales touchpoint. <br />
                    Especially useful for water parks running weekend flash sales, school group packages, or seasonal offers across multiple platforms simultaneously.</>,
                imageWidth: "44rem",
                imageHeight: "42rem",
                btnText: "Contact Sales",
                Image1: {
                    src: "/assets/waterPark/omnichannel-badge.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "18rem",
                    imageHeight: "20rem",
                    top: "8rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/waterPark/omnichannel-badge1.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "14rem",
                    imageHeight: "14rem",
                    bottom: "4rem",
                    left: "0rem",
                },


                points: [
                    <>Consolidate walk-in, online, and partner bookings on one platform.</>,
                    <>Prevent overbooking with live slot and capacity management.</>,
                    <>Real-time sync ensures no channel lag or reservation mismatch.</>,
                    <>Manage group bookings and bulk tickets with ease.</>,
                ],
            },
            {
                id: 6,
                image: "/assets/waterPark/Integrations_center.png",
                tag: "Integrations and Master Data Management",
                icon: "/assets/waterPark/Integrations_icon.svg",
                title: "Sync Every Operation Easily",
                desc: <>QueueBuster plugs directly into your existing ERP, keeping your water park's financials, inventory, and guest data perfectly aligned without any manual effort. Every locker token, every food combo, every issued wristband, everything is reflected instantly across your systems. <br />
                    Master Data Management ensures that product lists, pricing tiers, and category structures stay consistent across every outlet and touchpoint, leaving no room for data drift or discrepancy.</>,
                imageWidth: "44rem",
                imageHeight: "42rem",
                btnText: "Book a free demo",
                Image1: {
                    src: "/assets/waterPark/integrations-badge2.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "22rem",
                    imageHeight: "14rem",
                    top: "0rem",
                    right: "0rem",
                },
                Image3: {
                    src: "/assets/waterPark/integrations-badge1.svg",
                    alt: "Active RFID bands badge",
                    imageWidth: "22rem",
                    imageHeight: "20rem",
                    bottom: "-6rem",
                    left: "0rem",
                },


                points: [
                    <>Real-time sync between ticketing, F&B revenue, and finance records.</>,
                    <>Centralized master data, no pricing mismatches across counters.</>,
                    <>Eliminate manual reconciliation with automated ERP data flow.</>,
                    <>Full operational visibility from entry gate to back office</>,
                ],
            },

        ]
    };

    const parksFeatures = [
        {
            id: 1,
            image: "/assets/waterPark/WaterPark.webp",
            title: "Kid’s splash zones ",
        },
        {
            id: 2,
            image: "/assets/waterPark/Spa.webp",
            title: "Spa & Wellness Pools ",
        },
        {
            id: 3,
            image: "/assets/waterPark/RetailMerchandise.webp",
            title: "Retail Merchandise",
        },

        {
            id: 4,
            image: "/assets/waterPark/FoodCourts.webp",
            title: "Food Courts & Restaurants",
        },
        {
            id: 5,
            image: "/assets/waterPark/kids-play.png",
            title: "Events & Party Zones",
        },

    ]

    return (
        <div style={{ fontFamily: "GilroyMedium" }}>
            <HeroSection data={topSection} />
            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 9rem", boxSizing: "border-box" }}>
                <EntertainmentClientsMarquee />
            </div>
            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 9rem", boxSizing: "border-box" }}>
                <IAAPISection />
            </div>


            <div className={styles.features_section}>
                <div className={styles.features_section_badge}>
                    <h1>Smart Features of Billing Software for Water Park!</h1>
                </div>
                <FeaturesSection data={waterParkFeatures.data} centerImages={[waterParkFeatures.centerImage2]} />
            </div>

            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 9rem", boxSizing: "border-box" }}><ParksFeaturesSection data={parksFeatures} title="Water Parks, Food Courts, Wave Pools, Adventure Zones, We Power it all!" /></div>

            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 18rem", boxSizing: "border-box" }}>
                <div className={styles.section_heading} >
                    <h3 style={{ fontSize: "2.5rem" }}>The QueueBuster Experience</h3>

                </div>
                <QueueBusterExperienceCentersSection />
            </div>
            <div style={{ maxWidth: "1850px", margin: "0 auto", padding: "0 8rem", boxSizing: "border-box" }}><ThemeParkReviewsSection /></div>


            <div className={styles.featuresSection}><br />

                <div><BusinessUnlockSection /></div>
                <div><CaseStudiesSection /></div>
                <div style={{ margin: "0 0rem 8rem 0rem " }}> <ConnectWithUs /></div>

                <NewFaqSection FaqTableData={faqs} heading={"FAQ's for the QueueBuster Water Park billing software"} />
                <div>
                    <NewsAndVideos />
                </div>
            </div>

        </div>
    )
}

export default DesktopWaterPark
